// src/app/columnas-producto.constants.ts

import { Validators } from '@angular/forms';

/**
 * Identificadores de siriiagro.tipo_producto.
 *
 * Se comparan por id y no por nombre para que un cambio en el nombre visible
 * del tipo de producto (HU130: "Alimento balanceado para animales." pasa a
 * "Nutrición animal") no rompa la carga masiva ni la selección de empaques.
 *
 * Los valores son cadenas porque provienen del atributo value de un <select>.
 */
export enum TipoProductoId {
    Plaguicida = '1',
    Fertilizante = '2',
    Coadyuvante = '3',
    NutricionAnimal = '4',
    AcondicionadorEnmienda = '5',
}

export const columnasCoadyuvantes = [
    {
        nombre: 'Registro ICA',
        campo: 'numeroRegistroIca',
        tipo: 'text',
        obligatorio: true,
        validaciones: [Validators.required, Validators.pattern('[A-Z0-9]+')],
    },
    {
        nombre: 'Nombre comercial',
        campo: 'nombreComercial',
        tipo: 'text',
        mayusculas: true,
        obligatorio: true,
        validaciones: [Validators.required],
    },
    {
        nombre: 'Casa productora / Planta productora',
        campo: 'casaProductora',
        tipo: 'text',
        obligatorio: true,
        validaciones: [Validators.required],
    },
    {
        nombre: 'Origen del producto',
        campo: 'OrigenDelProducto',
        tipo: 'select',
        opciones: ['Producto importado', 'Producto Nacional'],
        validaciones: [Validators.required],
    },
];

export const columnasAlimentoBalanceado = [
    {
        nombre: 'Registro ICA',
        campo: 'numeroRegistroIca',
        tipo: 'text',
        obligatorio: true,
        validaciones: [Validators.required, Validators.pattern('[A-Z0-9]+')],
    },
    {
        nombre: 'Nombre comercial',
        campo: 'nombreComercial',
        tipo: 'text',
        obligatorio: true,
        mayusculas: true,
        validaciones: [Validators.required],
    },
    {
        nombre: 'Casa productora / Planta productora',
        campo: 'casaProductora',
        tipo: 'text',
        obligatorio: true,
        validaciones: [Validators.required],
    },
];

export const columnasAcondicionadorEnmienda = [
    {
        nombre: 'Registro ICA',
        campo: 'numeroRegistroIca',
        tipo: 'text',
        obligatorio: true,
        validaciones: [Validators.required, Validators.pattern('[A-Z0-9]+')],
    },
    {
        nombre: 'Nombre comercial',
        campo: 'nombreComercial',
        tipo: 'text',
        obligatorio: true,
        mayusculas: true,
        validaciones: [Validators.required],
    },
    {
        nombre: 'Casa productora / Planta productora',
        campo: 'casaProductora',
        tipo: 'text',
        obligatorio: true,
        validaciones: [Validators.required],
    },
    {
        nombre: 'Origen del producto',
        campo: 'OrigenDelProducto',
        tipo: 'select',
        opciones: ['Producto importado', 'Producto Nacional'],
        validaciones: [Validators.required],
    },
];
